import { useIntl } from '@/intl'
import { Slider } from '@sunwebgroup/ui-components'
import * as React from 'react'
import { useControlledSliderWithOpenRange, useValueFilter } from '../../../../../domain/hooks'
import FilterGroup from '../FilterGroup'
import { RangeLabel } from './RangeLabel'

export function PricePerPersonFilter() {
  const intl = useIntl()

  const { isFetching, selectedValue, setSelection } = useValueFilter('PricePerPerson')

  const { labelProps, sliderProps } = useControlledSliderWithOpenRange(selectedValue, setSelection)

  return (
    <FilterGroup title={intl.formatMessage({ id: 'accommodation_price_label' })} defaultOpen>
      <RangeLabel {...labelProps} disabled={isFetching} />
      <Slider {...{ ...sliderProps, withoutIcon: true }} ariaLabel="no-label" disabled={isFetching} />
    </FilterGroup>
  )
}
